module.exports = __webpack_public_path__ + "static/media/interior.6adb19d1.jpeg";


//////////////////
// WEBPACK FOOTER
// /src/images/residence/interior.jpeg
// module id = 1609
// module chunks = 0